import React from "react";
import { useEffect, useState } from "react";
import ResctrictImg from "../src/assets/restrict.png"

const DeviceRestriction = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 1024); // Adjust breakpoint as needed
    };

    checkDevice(); // Initial check
    window.addEventListener("resize", checkDevice); // Listen for resize

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return isMobile ? (
    children
  ) : (
    <div className="restrictionContainer">
        <img src={ResctrictImg} alt="" srcset="" />
      <h1>Access Restricted</h1>
      <p>
        This Application is Accessible on Mobile & Tablet Devices Only.
      </p>
    </div>
  );
};

export default DeviceRestriction;
